import styles from './SideMenu.module.scss'
import { useEffect, useState } from "react";
import { HiMenu } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUser, getUserClinic } from 'store/auth-slice';
import { setGettingStartedState } from "store/tour-slice"

import { FaBell, FaUser, FaQuestion } from 'react-icons/fa';
import api from "../../../helpers/api";
import Notifications from "../Notifications/Notifications";
import { Link } from 'react-router-dom';
import PageHeader from "../PageHeader/PageHeader";
import Tooltip from "../Tooltip/Tooltip";

const defaultLogo = 'https://smartclinic-public.s3.eu-west-1.amazonaws.com/uploads/marketing/52ddb55524b0565c5159b240129df52c.jpg';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

function useWindowDimensions() {
    const [ windowDimensions, setWindowDimensions ] = useState(
        getWindowDimensions()
    );

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
            // console.log('SideMenu: resize', styles.tabletDimension)
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
}


const SideMenu = (props) => {
    const dispatch = useDispatch();
    const [ expanded, setMenuExpanded ] = useState(false);
    const { height, width } = useWindowDimensions();
    const clinicData = useSelector((state) => state.auth.accountData)
    const authUser = useSelector((state) => state.auth.user)
    const [ user, setUser ] = useState(null);
    const location = useLocation();
    const [ showNotifications, toggleNotifications ] = useState(false);
    const [ notificationsCount, setNotificationsCount ] = useState(0);

    const storeUser = useSelector(state => state.auth.user)
    const storeOrg = useSelector(state => state.auth.clinic)

    useEffect(() => {
        const asyncFunc = async () => {
            let res = await api.get('notification/count');
            if (res.data) {
                setNotificationsCount(res.data)
            }
        }

        asyncFunc().then();
    }, [ clinicData, dispatch ]);

    const loadUser = async () => {
        const getUserData = await dispatch(getUser());
        const userObject = { ...getUserData }
        const org = await dispatch(getUserClinic());
        userObject.org = org;
        setUser(userObject);
    }

    useEffect(() => {
        loadUser()
        setMenuExpanded(false)
    }, [ location, storeUser, storeOrg ]);

    function toggleNotificationsPanel() {
        toggleNotifications(!showNotifications);
    }

    function getPageHeader() {
        return 'Header';
    }

    const userLogo = user && user?.org && user.org?.logo && user.org.logo !== defaultLogo ? user.org.logo : null;
    return (
        <div className={ styles[ 'container' ] }>
            { width <= 768 ?
                <div className={ styles[ 'expandButton' ] } onClick={ () => setMenuExpanded(true) }>
                    <HiMenu />
                </div>
                :
                null
            }

            { expanded ?
                <div className={ `${styles[ 'overlay' ]}` } onClick={ () => setMenuExpanded(false) }>

                </div>
                :
                null
            }

            <div
                className={ `${styles[ 'scrollbar-hidden' ]} ${styles[ 'sideBar' ]} ${(expanded ? styles[ 'expandedSideBar' ] : null)}` }>
                { width <= 768 ?
                    <div className={ styles[ 'collapseButton' ] } onClick={ () => setMenuExpanded(false) }>
                        <IoClose />
                    </div>
                    :
                    null
                }
                { props.children[ 0 ] }
            </div>

            <div className={ `${styles[ 'main' ]}` } id="content">
                <div className={ styles.topMenu }>
                    {/*
                    <div className={styles.topMenuStart}>
                        Welcome, {user && user?.org ? user.org.name : ''}
                    </div>
                    */}
                    <div className={ styles.topMenuList }>
                        <a className={ styles.topMenuItem } href="#" onClick={ (e) => {
                            e.preventDefault();
                            toggleNotificationsPanel()
                        } }>
                            <div className={ styles.topMenuIcon }>
                                <span
                                    className={ styles.iconBadge }>{ notificationsCount > 99 ? '99+' : (notificationsCount > -1 ? notificationsCount : 0) }</span>
                                <FaBell className={ styles.topMenuItemImg } />
                            </div>
                        </a>
                        { authUser && authUser.role < 5 && <a className={ styles.topMenuItem } href="#" onClick={ (e) => {
                            e.preventDefault();
                            dispatch(setGettingStartedState(true));
                        } }>
                            <div className={ styles.topMenuIcon }>
                                <FaQuestion className={ styles.topMenuItemImg } />
                            </div>
                        </a> }

                        <Tooltip content={ <div><div style={ { textAlign: 'center' } }>{ user ? user.name : '' }</div><div style={ { textAlign: 'center' } }>{ user ? user.email : '' }</div></div> }>
                            <Link to="/account" className={ styles.topMenuItem }>
                                <div className={ !userLogo ? styles.topMenuIcon : styles.topMenuImg }>
                                    { user && user?.org && user.org?.logo && user.org.logo !== defaultLogo ?
                                        <img src={ user.org.logo } className={ styles.topMenuImgProfile } /> :
                                        <FaUser className={ styles.topMenuItemImg } /> }
                                </div>
                                <div>
                                    { user && user?.org ? user.org.name : '' }
                                </div>
                                { user && user.role && user.role === 5 ? <div>Admin</div> : null }
                            </Link>
                        </Tooltip>
                    </div>
                </div>

                <PageHeader />

                { showNotifications ?
                    <Notifications onNotificationsCountChange={ (data) => setNotificationsCount(data.count) }
                        onClose={ () => toggleNotificationsPanel() } />
                    :
                    null }
                { props.children[ 1 ] }

                { props.children[ 2 ] }

            </div>
        </div>
    )
};

export default SideMenu;
